export const getRoomCode = state => { return state.roomCode }
export const isMobile = state => { return state.device }
export const getCharacter = state => { return state.character }
export const getTreasure = state => { return state.treasureList }


// WEBPACK FOOTER //
// ./src/store/getters.js